import { format as urlformat } from 'url';
import { getGuid } from 'owa-guid';
import { IAddinCommand } from 'owa-addins-store';

const OMEX_PROTOCOL: string = 'https';
const OMEX_HOST: string = 'store.office.com';
const OMEX_PATH: string = 'client/consentnotification.aspx';
const OMEX_CLIENT_TYPE: string = 'WAC_Outlook';

// This interface is a contract between extensibility and omex
// Please do not change this without consulting with omex team
interface OmexIframeNotificationUrlParameterKeys {
    //AppName
    client: string;

    //AppVersion
    cv: string;

    //AppUILocale
    ui: string;

    appDomain: string;

    //StoreLocator
    rs: string;

    assetid: string;

    notificationType: NotificationType;

    //CorrelationId
    corr: string;

    //WebApplication id (available for sso addin to use in consent for sideloaded addins)
    appid: string;

    //WebApplication scopes (available for sso addin to use in consent for sideloaded addins)
    scopes: string;
}

const enum NotificationType {
    TrustYellowBar = 0,
    ConsentYellowBar = 1,
    ConsentWhiteDialog = 2,
}

export default function buildOmexConsentUrl(
    addinCommand: IAddinCommand,
    userCulture: string,
    owaVersion: string
): string {
    const queryParameters = <OmexIframeNotificationUrlParameterKeys>{
        client: OMEX_CLIENT_TYPE,
        cv: owaVersion,
        ui: userCulture,
        appDomain: window.location.origin,
        rs: addinCommand.extension.MarketplaceContentMarket,
        notificationType: NotificationType.ConsentWhiteDialog,
        corr: getGuid(),
    };

    if (addinCommand.extension.MarketplaceAssetID) {
        queryParameters.assetid = addinCommand.extension.MarketplaceAssetID;
    } else {
        queryParameters.appid = addinCommand.extension.WebAppId;
        queryParameters.scopes = addinCommand.extension.WebAppScopes.join(',');
    }

    const url = urlformat({
        protocol: OMEX_PROTOCOL,
        host: getOmexHost(),
        pathname: OMEX_PATH,
        query: queryParameters,
    });
    return url;
}

function getOmexHost(): string {
    //Will be updated to return one of multiple hosts upon completion of https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/36603
    return OMEX_HOST;
}
